module.exports = __webpack_public_path__ + "static/hero1-2463fe5f71289466e8cc092414089b9f.png";